import { OrderStacks } from '@/entities/api/order/order-stacks'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface OrderSlice {
    orders: OrderStacks | null
}

const initialState: OrderSlice = {
    orders: null,
}

const orderSlice = createSlice({
    name: 'orders',
    initialState,
    reducers: {
        setOrdersFn: (state, action: PayloadAction<OrderStacks>) => {
            state.orders = action.payload
        },
        clearOrdersFn: (state) => {
            state.orders = null
        }    
    },
})

export const { setOrdersFn, clearOrdersFn } = orderSlice.actions

export default orderSlice.reducer
